:host {
  display: block;
}

.bread-crumb-current {
  stroke: var(--clrs-color-bread-crumb-current);
}

.bread-crumb-completed {
  fill: var(--clrs-color-bread-crumb-completed);
}

.loader-icons-bar {
  stroke: var(--clrs-color-loader-icons-bar);
}
.loader-icons-bar-completed {
  fill: var(---clrs-color-loader-icons-bar-completed);
}